import Close from "@mui/icons-material/Close";
import { Alert, AlertTitle, IconButton, Stack } from "@mui/material";
import { useLocalStorageValue } from "@react-hookz/web";
import type { FC } from "react";

export const PreviewAlert: FC<{ sendTestButton?: React.ReactNode }> = ({ sendTestButton }) => {
  const { set: setShowPreviewInfoMessage, value: showPreviewInfoMessage } = useLocalStorageValue(
    "showPreviewInfoMessage",
    { defaultValue: true },
  );

  if (!showPreviewInfoMessage || !sendTestButton) return null;

  return (
    <Alert
      severity="warning"
      action={
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="flex-end"
          minWidth={200}
        >
          {sendTestButton}
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setShowPreviewInfoMessage(false)}
            data-analytics-id="preview-dialog-close-info"
          >
            <Close fontSize="small" />
          </IconButton>
        </Stack>
      }
    >
      <AlertTitle>Preview shows content, not final layout</AlertTitle>
      Preview allows you to see merge tags and dynamic content as a specific recipient. Appearance
      may vary in Slack, Teams, or email based on recipient settings and device. Send a test to
      yourself to see how it looks on your device, without merge tags or dynamic content.
    </Alert>
  );
};
